export function tpDalisMaskFilter(value) {
  // let mask = [/\d/, /(\d|\/)/, /\d/, /\d/, /\d/]
  let mask = [/\d/, / /, /(\d|\/)/, / /, /\d/, /\d/, /\d/]
  const numbers = value.replace(/[^(0-9|\/)]/g, '')
  if (numbers.length >= 1 && numbers.charAt(0) !== '/') {
    mask[1] = ' '
    mask[2] = '/'
    mask[3] = ' '
  }
  return mask
}
